import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import HotelDetail from '../../../components/HotelDetail/HotelDetail';
import HotelFeedbackLink from './HotelFeedbackLink';
// import HotelDetailContainer from './HotelDetailContainer';

class HotelDetailModal extends React.Component {
  render() {
    const distanceTo = { distance: this.props.hotel.distance };
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.hotel.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid">
              <HotelDetail hotel={this.props.hotel} distanceTo={distanceTo} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <HotelFeedbackLink id={this.props.hotel.id} />
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

HotelDetailModal.propTypes = {
  hotel: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default HotelDetailModal;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelDetailModal.js